import $ from 'jquery';
import Dropzone from 'dropzone';
import slugify from 'slugify';
import { handleSidebarBackgrounds, sidebarLoader } from '~src/sidebar/index';
import { showSidebarTab, hideSidebarTab } from '~src/sidebarLegacy';
import { getAxiosClient } from './api';
import { isLoggedUserGlobalEditor } from '~src/user';
import { modifyState } from '~src/state';

Dropzone.autoDiscover = false;

const uploadBackgrounds = async (
  base64String,
  filename,
  width,
  height,
  tags
) => {
  $('#tab-backgrounds-tag-upload #editor-btn-spinner').show();
  const httpClient = await getAxiosClient();
  const isGlobalEditor = await isLoggedUserGlobalEditor();

  let orientation;
  if (width > height) {
    orientation = 'h';
  } else {
    orientation = 'v';
  }
  if (width === height) {
    orientation = 's';
  }

  if (isGlobalEditor) {
    const data = {
      toFile_file: {
        b64: base64String,
        name: slugify(filename),
      },
      demo: true,
      isGlobal: true,
      orientation,
      width,
      height,
      relations: [
        {
          column: 'tags',
          class: 'editor_images_tags',
          toIds: tags,
        },
      ],
    };

    return httpClient.post(
      `${process.env.PARSE_API_URL}/editor_backgrounds_default`,
      {
        data,
      }
    );
  } else {
    const data = {
      toFile_file: {
        b64: base64String,
        name: slugify(filename),
      },
      orientation,
      width,
      height,
      relations: [
        {
          column: 'tags',
          class: 'editor_images_tags',
          toIds: tags,
        },
      ],
    };

    return httpClient.post(`${process.env.PARSE_API_URL}/editor_backgrounds`, {
      data,
    });
  }
};

function createDropzoneBackgrounds() {
  const previewTemplate = `<div
  class="items-tag-image-container">
    <img
        src="../assets/svg/img-loader.gif"
        class="lazy items-tag-image"
    />
  </div>`;

  const dropzoneBackgrounds = new Dropzone('#sidebar-box-backgrounds', {
    maxFiles: 20,
    autoProcessQueue: false,
    url: '/',
    timeout: 0,
    previewTemplate: previewTemplate,
    acceptedFiles: 'image/jpeg,image/jpg,image/png,image/gif,image/svg+xml',
    previewsContainer: '#editor-sidebar-backgrounds', // Define the container to display the previews
    clickable: '#editor-sidebar-backgrounds-upload-btn', // Define the element that should be used as click trigger to select files.
  });

  dropzoneBackgrounds.on('thumbnail', (file) => {
    $('#tab-backgrounds-tag-upload #editor-btn-spinner').show();

    setTimeout(() => {
      if (typeof file.accepted !== 'undefined' && file.accepted === false) {
        console.error('File not accepted', file.accepted);
        return;
      }

      const reader = new FileReader();
      reader.onload = async (event) => {
        // event.target.result contains base64 encoded image
        const base64String = event.target.result;
        const fileName = slugify(file.name, {
          strict: true, // strip special characters except replacement, defaults to `false`
        });

        const selectedTags = $('#tagBackgroundSelectUpload').val();

        try {
          sidebarLoader('editor-sidebar-backgrounds');
          await uploadBackgrounds(
            base64String,
            fileName,
            file.width,
            file.height,
            selectedTags
          );
          await handleSidebarBackgrounds(true);
          $('#tab-backgrounds-tag-upload #editor-btn-spinner').hide();

          showSidebarTab('manifesti');
          hideSidebarTab('backgrounds-tag-upload');
        } catch (error) {
          console.error(error);
        }
      };
      reader.readAsDataURL(file);
    }, 100);
  });

  modifyState('dropzoneBackgrounds', dropzoneBackgrounds);
}

export { uploadBackgrounds, createDropzoneBackgrounds };
